export default function (): boolean {
  return false;
}
